export * from './lib/sku-capsule-feature-sku-feedback.module';
